import moment from "moment";

export const FinancealYearStartDateEndDate = () => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;

    const financialYearStart = currentMonth >= 4
        ? new Date(currentYear, 3, 1)
        : new Date(currentYear - 1, 3, 1);

    let details = {};
    details.startDate = moment(financialYearStart).format('YYYY-MM-DD');
    details.endDate = moment(currentDate).format('YYYY-MM-DD');

    return details
}